import { AttributeGroupDTO, Page } from '@touche-lts/panel-ui/dist'
import { ApiType, settings } from 'config'
import { GeneralStore, UserRequest } from 'mobx-stores'
import { CustomerHistoryTableSortProps, CustomersTableHistorySearchProps } from 'mobx-stores/customers/customer-history-table-store/customer-history-table-store.types'
import { CustomersTableSearchProps, CustomersTableSortProps } from 'mobx-stores/customers/customers-table/customers-table-store.types'
import { DepartmentsTableSortProps } from 'mobx-stores/departments/departments-table/departments-table-store.types'
import { LegalTableSortProps } from 'mobx-stores/legal/legal-table/legal-table-store.types'
import { StoresTableSortProps } from 'mobx-stores/stores/stores-table-store/stores-table-store.types'
import { ProductsTableSortProps } from 'mobx-stores/utils'
import { OrdersTableSearchProps } from 'mobx-stores/utils/orders-table-base/orders-table-base.types'
import { ActionHistoryTableSearchProps, ActionHistoryTableSortProps } from 'mobx-stores/utils/action-history-table-base/action-history-table-base.types'
import {
  OrdersDTO,
  ProductsFilterDTO,
  ProductsTableEntityDTO,
  StoreDTO,
  StoreFilterDTO,
  StoreTableEntryDTO,
  UserDTO,
  UserRoleDTO,
} from 'models'
import { CustomerAggregateDTO, CustomerDTO, CustomerOrdersHistory, CustomerStoresVisited } from 'models/customers'
import { DepartmentCategory, DepartmentsDTO } from 'models/departments'
import { DepartmentsFilterDTO } from 'models/departments-filter'
import { DepartmentsTableEntityDTO } from 'models/departments-table-entity'
import { LegalFilterDTO } from 'models/legal-filter'
import { LegalTableEntityDTO } from 'models/legal-table-entry'
import { Notifications } from 'models/notifications'
import { ReviewDTO } from 'models/review'
import { StatisticsHighlights, StatisticsPayloadDTO, StatisticsTableEntryDTO, StoreAdminHighlightsDTO } from 'models/statistics'
import { UsersStoreData } from 'services'
import {
  AllowedSsoEmailDTO,
  AuthPayload,
  FetchOptions,
  LoginPayload,
  PageQueryParams,
  SignUpPayload,
  SocialLoginPayload,
  SocialRegisterPayload,
  ShopifyLoginPayload,
  ShopifyRegisterPayload
} from './api.types'
import { Fetch } from './fetch'
import { ApiKeyDTO, ApiKeyFilterDTO } from '../../models/api-key'
import { ApiKeysTableSortProps } from '../../mobx-stores/setting-store/api-keys-table-store'

  const getHeaders = () => {
  const jwt =JSON.parse(window.localStorage.getItem('jwt')) 
  const headerAuth = `${jwt.tokenType} ${jwt.accessToken}`
  return {
    'Content-Type': 'application/json',
    Authorization: headerAuth,
  }
}

export class Api {
  private get: Fetch['get']
  private post: Fetch['post']
  private put: Fetch['put']
  private delete: Fetch['delete']
  private upload: Fetch['upload']
  private uploadSigned: Fetch['uploadSigned']

  //   accessKeyID: "AKIAWI674MAXKGCHH64Z"
  // bucketName: "touche-backoffice-test"
  // region: "eu-west-1"
  // secretAccessKey: "s7aMGn8sk8wjJoXvafQYlj+Kk+59HoSksVqxQ5KL"

  // private s3config = {
  //   dirName: 'images' /* optional */,
  //   accessKeyId: 'AKIAWI674MAXKGCHH64Z',
  //   bucketName: 'users-test',
  //   region: 'eu-west-1',
  //   secretAccessKey: 's7aMGn8sk8wjJoXvafQYlj+Kk+59HoSksVqxQ5KL'
  // }

  private s3config = {
    bucketName: null,
    dirName: 'images' /* optional */,
    region: null,
    accessKeyId: null,
    secretAccessKey: null
  }

  constructor(generalStore: GeneralStore) {
    const fetchService = new Fetch({
      onError: generalStore.handleApiError,
      onFetchStart: generalStore.setLoadingOn,
      onFetchEnd: generalStore.setLoadingOff
    })
    this.get = fetchService.get
    this.post = fetchService.post
    this.put = fetchService.put
    this.delete = fetchService.delete
    this.upload = fetchService.upload
    this.uploadSigned = fetchService.uploadSigned
  }

  private generateUrl = (
    url: string,
    options?: { apiType?: ApiType; pageQueryParams?: PageQueryParams }
  ): string => {
    const apiUrl = settings[options?.apiType || ApiType.MAIN]
    const pageQueryParamsUrl = this.generatePageQueryParamsUrl(
      options?.pageQueryParams
    )
    return `${apiUrl}${url}${pageQueryParamsUrl}`
  }

  private generatePageQueryParamsUrl = (params: PageQueryParams): string => {
    if (!params) return ''
    const searchParams = new URLSearchParams()
    searchParams.set('page', String(params?.page))
    searchParams.set('size', String(params.size))
    searchParams.set('sort', `${params?.sortProp},${params?.sortDirection}`)
    return '?' + searchParams.toString()
  }

  // public uploadFile = async (file: File): Promise<{ location: string }> => {
  //   if (!this.s3config.accessKeyId) {
  //     const url = this.generateUrl('/config/params/s3', {
  //       apiType: ApiType.USER
  //     })
  //     const res = await this.get(url)
  //     if (!res) return

  //     this.s3config.bucketName = res['s3.bucketName']
  //     this.s3config.region = res['s3.region']
  //     this.s3config.accessKeyId = res['s3.accessKeyID']
  //     this.s3config.secretAccessKey = res['s3.secretKey']
  //   }

  //   const result = await this.upload(file, this.s3config)
  //   return result
  // }

  
  /** GCP file upload */
   static async uploadFile(
    file: any,
    progressCallback?: (progressEvent: ProgressEvent) => void
  ): Promise<{ location: string }> {
    
  const jwt = JSON.parse(window.localStorage.getItem('jwt')) 
  const headerAuth = `${jwt.tokenType} ${jwt.accessToken}`

     try {
      let res:any = await fetch(`${settings[ApiType.MAIN]}/mediaContent/presigned?objectKey=${encodeURIComponent(file?.path)}`,{
        method : "GET",
        headers : getHeaders()
      });

      res = await res?.json();
      const location = res?.location;

      if(res?.url && res?.location){
       try {
        const formData = new FormData();

        if(file && file?.path) {
          formData.append("body",file ,file?.path)
        }

        res = await fetch(res?.url,{
          method : "POST",
         headers : {
          Authorization: headerAuth,
          },
          body: formData
        });

        res = await res.json();

        return 
       } catch (error) {

       }
      }

      return {location };
      
     } catch (error) {
      
     }

  }

  public uploadFileSigned = async (
    file: File
  ): Promise<{ location: string }> => {
    const url = this.generateUrl(
      `/mediaContent/presigned?objectKey=${encodeURIComponent(file.name)}`,
      {
        apiType: ApiType.MAIN
      }
    )
    const res = await this.get(url)
    if (!res) return
    const result = await this.uploadSigned(file, res)
    return result
  }

  public userApi = {
    login: async (payload: LoginPayload): Promise<AuthPayload> => {
      const url = this.generateUrl('/admin/login', { apiType: ApiType.USER })
      return await this.post(url, payload)
    },
    getUserRoles: async (): Promise<UserRoleDTO[]> => {
      const url = this.generateUrl('/config/roles', { apiType: ApiType.USER })
      return await this.get(url)
    },
    inviteUser: async (userRequest: UserRequest): Promise<UserDTO> => {
      const url = this.generateUrl('/user/invite', { apiType: ApiType.USER })
      return await this.post(url, userRequest)
    },
    getUser: async (userId: number | string): Promise<UserDTO> => {
      const url = this.generateUrl(`/users/${encodeURIComponent(userId)}`, {
        apiType: ApiType.USER
      })
      return await this.get(url)
    },
    saveUser: async (user: UserDTO): Promise<UserDTO> => {
      const url = this.generateUrl('/user/save', { apiType: ApiType.USER })
      return await this.post(url, user)
    },
    getAllUsers: async (options?: FetchOptions): Promise<UserDTO[]> => {
      const url = this.generateUrl('/users/all', { apiType: ApiType.USER })
      return await this.get(url, options)
    },
    signUp: async (
      code: string,
      payload: SignUpPayload,
      options?: FetchOptions
    ): Promise<AuthPayload> => {
      const url = this.generateUrl(`/code/${encodeURIComponent(code)}`, { apiType: ApiType.USER })
      return await this.post(url, payload, options)
    },
    socialLogin: async (payload: SocialLoginPayload, options?: FetchOptions): Promise<AuthPayload> => {
      const url = this.generateUrl('/social-login', { apiType: ApiType.USER })
      return await this.post(url, payload, options)
    },
    socialRegister: async (payload: SocialRegisterPayload): Promise<{ message: string }> => {
      const url = this.generateUrl('/social-register', { apiType: ApiType.USER })
      return await this.post(url, payload)
    },
    getGoogleAuthUrl: async (client: string): Promise<{ url: string }> => {
      const url = this.generateUrl(`/auth/google-url?client=${encodeURIComponent(client)}`, { apiType: ApiType.USER })
      return await this.get(url)
    },
    getMicrosoftAuthUrl: async (client: string): Promise<{ url: string }> => {
      const url = this.generateUrl(`/auth/microsoft-url?client=${encodeURIComponent(client)}`, { apiType: ApiType.USER })
      return await this.get(url)
    },
    getAppleAuthUrl: async (client: string): Promise<{ url: string }> => {
      const url = this.generateUrl(`/auth/apple-url?client=${encodeURIComponent(client)}`, { apiType: ApiType.USER })
      return await this.get(url)
    }
  }

  public shopifyApi = {
    login: async (payload: ShopifyLoginPayload): Promise<AuthPayload> => {
      const url = this.generateUrl('/auth/login', { apiType: ApiType.MAIN })
      return await this.post(url, payload)
    },
    register: async (payload: ShopifyRegisterPayload): Promise<AuthPayload> => {
      const url = this.generateUrl('/auth/shopify/register', { apiType: ApiType.MAIN })
      return await this.post(url, payload)
    }
  }

  public storeApi = {
    getStores: async (options?: FetchOptions): Promise<StoreDTO[]> => {
      const url = this.generateUrl('/stores')
      return await this.get(url, options)
    },
    createStore: async (storeDto: StoreDTO): Promise<StoreDTO> => {
      const url = this.generateUrl('/stores')
      return await this.post(url, storeDto)
    },
    getStoreById: async (storeId: number | string): Promise<StoreDTO> => {
      const url = this.generateUrl(`/stores/${encodeURIComponent(storeId)}`)
      return await this.get(url)
    },
    updateStore: async (storeDto: StoreDTO): Promise<StoreDTO> => {
      const url = this.generateUrl(`/stores/${encodeURIComponent(storeDto.id)}`)
      return await this.put(url, storeDto)
    },
    suspendStore: async (storeId: number | string): Promise<StoreDTO> => {
      const url = this.generateUrl(`/stores/${encodeURIComponent(storeId)}`)
      return await this.delete(url)
    },
    activateStore: async (storeId: number | string): Promise<StoreDTO> => {
      const url = this.generateUrl(`/stores/${encodeURIComponent(storeId)}/activate`)
      return await this.put(url, storeId)
    },
    assignUser: async (
      storeId: number | string,
      userDto: UserDTO,
      options?: FetchOptions
    ): Promise<StoreDTO> => {
      const url = this.generateUrl(`/stores/${encodeURIComponent(storeId)}/users`)
      return await this.post(url, userDto, options)
    },
    removeUser: async (
      storeId: number | string,
      emailAddress: string,
      options?: FetchOptions
    ): Promise<StoreDTO> => {
      const url = this.generateUrl(`/stores/${encodeURIComponent(storeId)}/users/${encodeURIComponent(emailAddress)}`)
      return await this.delete(url, options)
    },
    getAllProductsFiltered: async (
      storeId: number | string,
      filter: Partial<ProductsFilterDTO>,
      options?: FetchOptions<ProductsTableSortProps>
    ): Promise<Page<ProductsTableEntityDTO>> => {
      const url = this.generateUrl(`/stores/${encodeURIComponent(storeId)}/products/tableEntries`, {
        pageQueryParams: options?.pageQueryParams
      })
      return await this.post(url, filter, options)
    },
    getAllStoresFiltered: async (
      filter: StoreFilterDTO,
      options?: FetchOptions<StoresTableSortProps>
    ): Promise<Page<StoreTableEntryDTO>> => {
      const url = this.generateUrl('/stores/tableEntries', {
        pageQueryParams: options?.pageQueryParams
      })

      return await this.post(url, filter, options)
    },
    getUsersStores: async (options?: FetchOptions): Promise<UsersStoreData> => {
      const url = this.generateUrl('/stores/users')
      return await this.get(url, options)
    },
    getStoresByUser: async (
      emailAddress: string,
      options?: FetchOptions
    ): Promise<StoreDTO[]> => {
      const url = this.generateUrl(`/stores/users/${encodeURIComponent(emailAddress)}`)
      return await this.get(url, options)
    },
    storeOrdersFiltered: async (
      storeId: number | string,
      filters: Partial<OrdersTableSearchProps>,
      options?: FetchOptions
    ): Promise<Page<OrdersDTO>> => {
      const url = this.generateUrl(`/stores/${encodeURIComponent(storeId)}/orders`, {
        pageQueryParams: options?.pageQueryParams
      })
      return await this.post(url, filters, options)
    },
    getOrderById: async (
      orderId: number | string,
      options?: FetchOptions
    ): Promise<AttributeGroupDTO[]> => {
      const url = this.generateUrl(`/orders/${encodeURIComponent(orderId)}`)
      return await this.get(url, options)
    },
    generateAllTags: async (storeId: number | string): Promise<void> => {
      const url = this.generateUrl(`/store/${encodeURIComponent(storeId)}/generate-all-tags`)
      return await this.post(url, {})
    },
    getCurrentUserStores: async (options?: FetchOptions): Promise<StoreDTO[]> => {
      const url = this.generateUrl('/stores/current-user')
      return await this.get(url, options)
    },
  }

  public productApi = {
    allFilteredSorted: async (
      filter: Partial<ProductsFilterDTO>,
      options?: FetchOptions<ProductsTableSortProps>
    ): Promise<Page<ProductsTableEntityDTO>> => {
      const url = this.generateUrl('/products/all', {
        pageQueryParams: options?.pageQueryParams
      })
      return await this.post(url, filter, options)
    },
    getProductsFromShopify: async (
      storeId : number
    ): Promise<Page<ProductsTableEntityDTO>> => {
      const url = this.generateUrl(`/stores/${encodeURIComponent(storeId)}/productsFromShopify`)
      return await this.post(url,{})
    },
    getStoreAdminProducts: async (
      storeId: number | string,
      filter: Partial<ProductsFilterDTO>,
      options?: FetchOptions<ProductsTableSortProps>
    ): Promise<Page<ProductsTableEntityDTO>> => {
      const url = this.generateUrl(`/stores/${encodeURIComponent(storeId)}/products/tableEntries`, {
        pageQueryParams: options?.pageQueryParams
      })
      return await this.post(url, filter, options)
    },
  }

  public departmentsApi = {
    addDepartment: async (departmentDTO: Partial<DepartmentsDTO>): Promise<DepartmentsDTO> => {
      const url = this.generateUrl('/departments')
      return await this.post(url, departmentDTO)
    },
    updateDepartment: async (departmentDTO: Partial<DepartmentsDTO>): Promise<DepartmentsDTO> => {
      const url = this.generateUrl('/departments')
      return await this.put(url, departmentDTO)
    },
    addCategotyDepartment: async (departmentCategory: Partial<DepartmentCategory>, departmentId: number | string): Promise<DepartmentCategory> => {
      const url = this.generateUrl(`/departments/${encodeURIComponent(departmentId)}/categories`)
      return await this.post(url, departmentCategory)
    },
    allFilteredSorted: async (
      filter: DepartmentsFilterDTO,
      options?: FetchOptions<DepartmentsTableSortProps>
    ): Promise<Page<DepartmentsTableEntityDTO>> => {
      const url = this.generateUrl('/departments/all', {
        pageQueryParams: options?.pageQueryParams
      })
      return await this.post(url, filter, options)
    },
    getDepartmentById: async (departmentId: string | number): Promise<DepartmentsTableEntityDTO> => {
      const url = this.generateUrl(`/departments/${encodeURIComponent(departmentId)}`)
      return await this.get(url)
    },
    deactivateDepartmentId: async (departmentId: number | string): Promise<DepartmentsDTO> => {
      const url = this.generateUrl(`/departments/${encodeURIComponent(departmentId)}`)
      return await this.delete(url)
    },

  }

  public customersApi = {
    getAllCustomers: async (): Promise<CustomerAggregateDTO> => {
      const url = this.generateUrl('/statistics/customer-revenue');
      return await this.get(url);
    },

    getCustomerById: async (customerId: string): Promise<CustomerDTO> => {
      const url = this.generateUrl(`/customers/${encodeURIComponent(customerId)}`);
      return await this.get(url);
    },
    getCustomersOrders: async (
      customerId: string,
      filters: Partial<OrdersTableSearchProps>,
      options?: FetchOptions
    ): Promise<Page<CustomerOrdersHistory>> => {
      const url = this.generateUrl(`/customers/admin/${encodeURIComponent(customerId)}/orders`, {
        pageQueryParams: options?.pageQueryParams
      })
      return await this.post(url, filters, options)
    },

    getCustomerStoreVisited: async (
      customerId: string,
      filters: CustomersTableHistorySearchProps,
      options?: FetchOptions<CustomerHistoryTableSortProps>
    ): Promise<Page<CustomerStoresVisited>> => {
      const url = this.generateUrl(`/customers/${encodeURIComponent(customerId)}/stores`, {
        pageQueryParams: options?.pageQueryParams
      })
      return await this.post(url, filters, options)
    },

    allFilteredSorted: async (
      filter: CustomersTableSearchProps,
      options?: FetchOptions<CustomersTableSortProps>
    ): Promise<Page<CustomerAggregateDTO>> => {
      const url = this.generateUrl('/statistics/customer-revenue', {
        pageQueryParams: options?.pageQueryParams
      })
      return await this.post(url, filter, options)
    },
  }

  public statisticsApi = {
    getHighLights: async (
      filter?: StatisticsPayloadDTO
    ): Promise<StatisticsHighlights> => {
      const url = this.generateUrl(`/statistics/highlights`)
      return await this.post(url, filter)
    },
    getStoreStatisticsGraph: async (
      filter: Partial<ProductsFilterDTO>,
      options?: FetchOptions<ProductsTableSortProps>
    ): Promise<StatisticsTableEntryDTO[]> => {
      const url = this.generateUrl(`/statistics/stores/historic`)
      return await this.post(url, filter)
    },
    getAllStoreStatistics: async (
      filter: Partial<ProductsFilterDTO>,
      options?: FetchOptions<ProductsTableSortProps>
    ): Promise<StatisticsTableEntryDTO[]> => {
      const url = this.generateUrl(`/statistics/stores`)
      return await this.post(url, filter)
    },
    getStoreStatistics: async (
      storeId: number | string,
      filter: Partial<ProductsFilterDTO>,
      options?: FetchOptions<ProductsTableSortProps>
    ): Promise<StatisticsTableEntryDTO[]> => {
      const url = this.generateUrl(`/statistics/stores/${encodeURIComponent(storeId)}/products`)
      return await this.post(url, filter)
    },
    getStoreAdminHighlights: async (
      storeId: number | string,
      filter?: StatisticsPayloadDTO
    ): Promise<StoreAdminHighlightsDTO> => {
      const url = this.generateUrl(`/statistics/store-admin/${encodeURIComponent(storeId)}/highlights`)
      return await this.post(url, filter)
    },
  }

  public notificationsApi = {
    getNotifications: async (): Promise<Notifications[]> => {
      const url = this.generateUrl(`/notifications`)
      return await this.get(url,{silentProcess:true})
    },
    deleteNotification: async (notificationId: number) => {
      const url = this.generateUrl(`/notifications/${encodeURIComponent(notificationId)}`)
      return await this.delete(url)
    }
  }

  public legalApi = {
    getlegalPages: async (
      filter: LegalFilterDTO,
      options?: FetchOptions<LegalTableSortProps>
    ): Promise<Page<LegalTableEntityDTO>> => {
      const url = this.generateUrl('/legal-pages/search', {
        pageQueryParams: options?.pageQueryParams
      })
      return await this.post(url, filter, options)
    },
    getLegalPage: async (legalId: string): Promise<LegalTableEntityDTO> => {
      const url = this.generateUrl(`/legal-pages/${encodeURIComponent(legalId)}`)
      return await this.get(url)
    },
    addLegalPage: async (payload: LegalTableEntityDTO): Promise<LegalTableEntityDTO> => {
      const url = this.generateUrl('/legal-pages')
      return await this.post(url, payload)
    },
    updateLegalPage: async (payload: LegalTableEntityDTO): Promise<LegalTableEntityDTO> => {
      const url = this.generateUrl('/legal-pages')
      return await this.put(url, payload)
    },
  }

  public reviewsApi = {
    setStoreProductReviews: async (
      payload: Partial<ReviewDTO>
    ): Promise<ReviewDTO> => {
      const url = this.generateUrl(`/reviews`)
      return await this.post(url, payload)
    }
  }

  public actionHistoryApi = {
    getActionHistory: async (
      filter: Partial<ActionHistoryTableSearchProps>,
      options?: FetchOptions<ActionHistoryTableSortProps>
    ): Promise<Page<ActionHistoryTableSearchProps>> => {
      const url = this.generateUrl(`/action-history/admin`, {
        pageQueryParams: options?.pageQueryParams
      })
      return await this.post(url, filter, options)
    },

    getUserActionHistory: async (userId: number | string,
      filter: Partial<ActionHistoryTableSearchProps>,
      options?: FetchOptions<ActionHistoryTableSortProps>
    ): Promise<Page<ActionHistoryTableSearchProps>> => {
      const url = this.generateUrl(`/action-history/users/${encodeURIComponent(userId)}`, {
        pageQueryParams: options?.pageQueryParams
      })
      return await this.post(url, filter, options)
    },


  }

  public apiKeysApi = {
    getApiKeysFiltered: async (
      filter: ApiKeyFilterDTO,
      options?: FetchOptions<ApiKeysTableSortProps>
    ): Promise<Page<ApiKeyDTO>> => {
      const url = this.generateUrl("/api-key/all", {
        pageQueryParams: options?.pageQueryParams,
      });

      return await this.post(url, filter, options);
    },
    regenerateApiKey: async (storeId: number): Promise<ApiKeyDTO> => {
      const url = this.generateUrl(`/api-key/${encodeURIComponent(storeId)}/re-generate`);

      return await this.post(url, {});
    },
    autoGenerateApiKey: async (): Promise<ApiKeyDTO> => {
      const url = this.generateUrl("/api-key/auto-generate");

      return await this.post(url, {});
    },
  };

  public ssoAllowedEmailsApi = {
    list: async (): Promise<AllowedSsoEmailDTO[] | undefined> => {
      const url = this.generateUrl('/sso/allowed-emails', { apiType: ApiType.USER })
      return await this.get(url)
    },
    add: async (email: string): Promise<AllowedSsoEmailDTO | undefined> => {
      const url = this.generateUrl('/sso/allowed-emails', { apiType: ApiType.USER })
      return await this.post(url, { email })
    },
    update: async (id: number, email: string): Promise<AllowedSsoEmailDTO | undefined> => {
      const url = this.generateUrl(`/sso/allowed-emails/${encodeURIComponent(id)}`, { apiType: ApiType.USER })
      return await this.put(url, { email })
    },
    remove: async (email: string): Promise<boolean> => {
      const url = this.generateUrl(`/sso/allowed-emails/${encodeURIComponent(email)}`, { apiType: ApiType.USER })
      await this.delete(url)
      return true
    },
  };
}
